module.exports = ".btn-xs {\n  font: 400 10.3333px Arial !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component-table/radio-buttons-check-list/radio-buttons-check-list.component.scss
// module id = ./src/app/shared/component-table/radio-buttons-check-list/radio-buttons-check-list.component.scss
// module chunks = main